import React from 'react';
import { withTranslation } from 'react-i18next';
import { useStore } from '../../store';
import './header.scss';
import Menu from './Menu.jsx';
import { OmdaRettsAcademyLogo } from './omdaRettsAcademyLogo.jsx';



const Header = () => {
    const {
        state: {
            user: {
                logo
            }
        }
    } = useStore();

    return (
        <div className="headerContainer">
            <div className="logo">
                <a href={'/'}>                  
                    <OmdaRettsAcademyLogo />
                </a>
            </div>
            <div className="menuBar">
                <Menu/>
            </div>
        </div>
    );
};

export default withTranslation()(Header);
